import React from 'react';
import { Card } from './ui/card';
import { Target, Eye, Award } from 'lucide-react';

export const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-background">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            About{' '}
            <span className="text-primary">
              SAI Group
            </span>
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto mb-6 rounded-full"></div>
          <p className="text-lg text-muted-foreground leading-relaxed">
            A South Africa-based, pan-African diversified group of companies with over 30 years of combined industry experience
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <p className="text-base text-foreground/70 leading-relaxed">
              SAI Group is committed to building sustainable businesses that create long-term value for individuals, corporations, and communities across strategic sectors that drive economic growth on the African continent.
            </p>
            <p className="text-base text-foreground/70 leading-relaxed">
              From mobility and technology to capital investments, mining, media, healthcare, and real estate, we bring together innovation, financial strength, operational excellence, and deep market understanding.
            </p>
            <p className="text-base text-foreground/70 leading-relaxed">
              Rooted in South Africa and operating across Africa, SAI Group delivers scalable solutions tailored to Africa's unique economic landscape.
            </p>
            <div className="flex items-start space-x-3 bg-muted/50 p-4 rounded-lg">
              <Award className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-semibold text-foreground mb-1">Our Mission</h4>
                <p className="text-sm text-muted-foreground">
                  To empower people, enable businesses, and unlock Africa's full economic potential through smart investments, accessible services, and future-ready infrastructure.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1762758731221-044c22e651e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBtb2Rlcm58ZW58MHx8fHwxNzY2MzI0MDQ2fDA&ixlib=rb-4.1.0&q=85"
              alt="Modern Corporate Architecture"
              className="rounded-lg shadow-lg w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent rounded-lg"></div>
          </div>
        </div>

        {/* Vision & Values Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          <Card className="p-8 card-hover bg-card border-border">
            <div className="flex items-start space-x-4">
              <div className="bg-primary/10 p-3 rounded-lg">
                <Eye className="w-8 h-8 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-foreground mb-3">Our Vision</h3>
                <p className="text-muted-foreground leading-relaxed">
                  To become one of Africa's most trusted and influential multi-industry groups, driving inclusive growth, innovation, and sustainable development across the continent.
                </p>
              </div>
            </div>
          </Card>

          <Card className="p-8 card-hover bg-card border-border">
            <div className="flex items-start space-x-4">
              <div className="bg-primary/10 p-3 rounded-lg">
                <Target className="w-8 h-8 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-foreground mb-3">Why SAI Group</h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li className="flex items-start">
                    <span className="text-primary mr-2">•</span>
                    <span>30+ years of industry experience</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-2">•</span>
                    <span>Pan-African footprint with global partnerships</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-2">•</span>
                    <span>Commitment to sustainability and ethical business</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-2">•</span>
                    <span>Scalable solutions across multiple industries</span>
                  </li>
                </ul>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;